/**
 * SOURCE.2 — intrinsic MAGIC / Catalyst-provider calibration constants
 * (source-weapon-technique-hybrid-contract.md §23/§24). Versioned BalanceProfile seed values, not universal design laws —
 * a future calibration pass may version them, but a shipped Skill's
 * authored mana is never silently repriced by a later seed change (matching
 * Issue #28's own "skill age does not reprice mana" invariant).
 */

export const MAGIC_SOURCE_V1_VERSION = 'magic-source-v1-source2' as const;

/** Intrinsic MAGIC H_base seed relative to the same-tier Catalyst reference (contract §24). */
export const INTRINSIC_MAGIC_BASE_DAMAGE_RATIO = 0.80;

export interface MagicInfluenceSeed {
  readonly authoredManaMultiplier: number;
  readonly intrinsicActionCycleMultiplier: number;
  readonly intrinsicRecastCycleMultiplier: number;
}

export const MAGIC_INFLUENCE_PROFILE_V1: Readonly<Record<'LOW' | 'MEDIUM' | 'HIGH', MagicInfluenceSeed>> = Object.freeze({
  LOW: Object.freeze({
    authoredManaMultiplier: 1.30,
    intrinsicActionCycleMultiplier: 1.075,
    intrinsicRecastCycleMultiplier: 1.25,
  }),
  MEDIUM: Object.freeze({
    authoredManaMultiplier: 1.15,
    intrinsicActionCycleMultiplier: 1.15,
    intrinsicRecastCycleMultiplier: 1.65,
  }),
  HIGH: Object.freeze({
    authoredManaMultiplier: 1.00,
    intrinsicActionCycleMultiplier: 1.25,
    intrinsicRecastCycleMultiplier: 2.25,
  }),
});

/** SOURCE.2 §10.1: fixed intrinsic-basic action cadence seed — documented
 * here, consumed only by the reference/basic-fixture layer (Task 10), never
 * by per-skill `resolveMagicSourceSnapshot` (which uses the owner's real
 * `IntrinsicMagicSourceDefinition` rates instead). Basic attack has no
 * per-skill `MagicInfluence`, so this is intentionally independent of
 * `MAGIC_INFLUENCE_PROFILE_V1`. */
export const INTRINSIC_MAGIC_BASIC_ACTION_CYCLE_MULTIPLIER = 1.25;
